import { buildMultilineAction, addLineIndent } from '../utils'
import type { RefObject } from 'react'
import { markdownConfig } from '../../config'

export const indentByConstantAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  indentSize: number = markdownConfig.defaultIndent,
): boolean => {
  const action = buildMultilineAction<number>(
    () => (Number.isFinite(indentSize) ? indentSize : 0),
    (ctx) => addLineIndent(ctx),
  )
  return action(textareaRef, value, onChange)
}
